export default [
    {
        id: 'create-admin',
        title: 'Admin',
        icon: 'Admin',
        path: '/create-admin',
        roles: ['admin', 'sub-admin'],
        permission: ['CreateAdmins', 'ListAdmins'],
        requireAllPermissions: false,
    },
    {
        id: 'create-sub-admin',
        title: 'Sub Admin',
        icon: 'SubAdmin',
        path: '/create-sub-admin',
        roles: ['admin', 'sub-admin'],
        permission: ['CreateSubAdmins', 'ListSubAdmins'],
        requireAllPermissions: false,
    },
    {
        id: 'create-producer',
        title: 'Producer',
        icon: 'Producer',
        path: '/create-producer',
        roles: ['admin', 'sub-admin'],
        permission: ['ListProducers'],
    },
    {
        id: 'create-sub-producer',
        title: 'Sub Producer',
        icon: 'SubProducer',
        path: '/create-sub-producer/general',
        roles: ['admin', 'sub-admin', 'producer', 'sub-producer'],
        permission: ['CreateSubProducers', 'ListSubProducers'],
        requireAllPermissions: false,
    },
    {
        id: 'create-driver',
        title: 'Driver',
        icon: 'Driver',
        path: '/create-driver',
        roles: ['admin', 'sub-admin', 'transport', 'sub-transport'],
        permission: ['ListDrivers'],
    },
    {
        id: 'create-processor',
        title: 'Processor',
        icon: 'Processor',
        path: '/create-processor',
        roles: ['admin', 'sub-admin'],
        permission: ['ListProcessors'],
    },
    {
        id: 'create-sub-processor',
        title: 'Sub Processor',
        icon: 'SubProcessor',
        path: '/create-sub-processor',
        roles: ['admin', 'sub-admin', 'processor', 'sub-processor'],
        permission: ['CreateSubProcessors', 'ListSubProcessors'],
        requireAllPermissions: false,
    },
    {
        id: 'create-hauling-company',
        title: 'Hauling Company',
        icon: 'Hauling',
        path: '/create-hauling-company',
        roles: ['admin'],
        permission: ['ListHaulingCompanies'],
    },
    {
        id: 'create-sub-hauling',
        title: 'Sub Hauler',
        icon: 'SubHauling',
        path: '/create-sub-hauling',
        roles: ['admin', 'sub-admin', 'transport', 'sub-transport'],
        permission: ['CreateSubHauling', 'ListSubHauling'],
        requireAllPermissions: false,
    },
    {
        id: 'create-trailer',
        title: 'Trailer',
        icon: 'Trailer',
        path: '/create-trailer',
        roles: ['admin', 'transport', 'sub-transport'],
        permission: ['ListTrailers'],
        subPermissionOnly: true,
    },
    {
        id: 'create-schedule-route',
        title: 'Route',
        icon: 'Route',
        roles: ['admin'],
        path: '/create-route',
        permission: ['CreateRoutes'],
    },
    {
        id: 'create-sub-producer-accountant',
        title: 'Accountant',
        icon: 'Invoicing',
        path: '/create-sub-producer/accountant',
        roles: ['producer'],
        permission: ['CreateSubProducers'],
    },
    {
        id: 'create-sub-producer-feed',
        title: 'Feed Provider',
        icon: 'SubProducer',
        path: '/create-sub-producer/feed',
        roles: ['producer'],
        permission: ['CreateSubProducers'],
    },
    {
        id: 'create-sub-producer-nutritionist',
        title: 'Nutritionist',
        icon: 'SubProducer',
        path: '/create-sub-producer/nutritionist',
        roles: ['producer'],
        permission: ['CreateSubProducers'],
    },
    {
        id: 'create-sub-producer-co-owner',
        title: 'Co-Owner',
        icon: 'SubProducer',
        path: '/create-sub-producer/co-owner',
        roles: ['producer'],
        permission: ['CreateSubProducers'],
    },
];
